<div class="card">
    <!-- Payment Details Summary -->
    <div class="card-header">
      <div class="row">
        <div class="col-5">
          <p class="card-subtitle">This credit card will be used to process payments for paid SmilePass features you have enabled.</p>
        </div>
        <div class="col-3 offset-md-4">
          <button
            (click)="addNewPaymentMethod(customer.id)"
            class="btn btn-sm btn-primary btn-touchspin btn-touchspin-down"
          >ADD CARD</button>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 20px;" *ngFor="let method of filterStatus(paymentMethod); let methodNumber = index;">
        <div class="card-body" style="border: 1px solid #ccc; border-radius: 20px;" >
          <div class="row" *ngIf="method.type == 'card'">
            <div class="col-6">
              <img src='../../../../../assets/images/icons/card_{{ method.method_details.brand }}.png' style="height: 50px; border: 1px solid #ccc; border-radius: 10px;" />
            </div>
            <div class="col-6" style="text-align-last: right;">
              <button type="button" *ngIf="!method.primary_method" (click)="editPaymentMethod(method.id)" class="btn btn-primary mr-1" rippleEffect>Edit</button>
              <button type="button" *ngIf="paymentMethod.length > 1 && !method.primary_method" (click)="questionBeforeDeletePaymentMethod(method)" class="btn btn-secondary" rippleEffect>Delete</button>
              <button
              style="display: none;"
              id="deletePaymentMethod{{method.id}}"
              class="btn btn-outline-secondary"
              (click)="deletePaymentMethod(method.id)"
              type="button" rippleEffect
            >
            </button>
            </div>
  
            <div class="col-6 mt-1">
              <h4><b>{{method.billing_details.name}}</b></h4> 
              <p> **** **** **** <b>{{method.method_details.last4}}</b></p> 
              
            </div>
            <div class="col-6 mt-1" style="text-align: right;">
              <small>Card expires at {{ method.method_details.exp_month }}/{{ method.method_details.exp_year }}</small>
            </div>
          </div>
  
          <div class="row" *ngIf="method.type != 'card'">
            <div class="col-6">
              <img src='../../../../../assets/images/icons/{{method.type}}.png' style="height: 50px; border: 1px solid #ccc; border-radius: 10px;" />
            </div>
            <div class="col-6" style="text-align-last: right;">
              <button type="button" (click)="editPaymentMethod(method.id)" class="btn btn-primary mr-1" rippleEffect>Edit</button>
              <button type="button" (click)="questionBeforeDeletePaymentMethod(method)" class="btn btn-secondary" rippleEffect>Delete</button>
              <button
              style="display: none;"
              id="deletePaymentMethod{{method.id}}"
              class="btn btn-outline-secondary"
              (click)="deletePaymentMethod(method.id)"
              type="button" rippleEffect
            >
            </button>
            </div>
  
            <div class="col-6 mt-1">
              <h4><b>{{method.billing_details.name}}</b></h4> 
              <p> BSB: <b>{{method.method_details.bsb_number}}</b></p> 
              <p> Account: **** - <b>{{method.method_details.last4}}</b></p> 
              
            </div>
  
          </div>
            
          <div 
            class="badge badge-light-primary" 
            style="
              position: absolute;
              top: 0px;
              left: 45%;" 
            *ngIf="method.primary_method">
            Primary
          </div>
          <div 
            class="badge badge-light-warning" 
            style="
              position: absolute;
              top: 0px;
              left: 45%;" 
            *ngIf="method.status == 'paused'">
            Paused
          </div>
  
        </div>
        
  
  
      </div>
    <!-- /Payment Details Summary -->
  </div>

<!-- Modal Edit Payment Method -->
<ng-template #modalEditPaymentMethod let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title" id="myModalLabel160">Edit Payment Method</h5>
    </div>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>

    <div class="row">
      <div class="col-12 mb-2" style="text-align-last: center;">
        <div class="custom-control custom-switch custom-switch" >
          <input type="checkbox" class="custom-control-input" id="statusSwitch" [(ngModel)]="currentPaymentMethod.hasActiveStatus" [checked]="currentPaymentMethod.hasActiveStatus" />
          <label class="custom-control-label" for="statusSwitch">
            <span class="switch-icon-left"><i data-feather="check"></i></span>
            <span class="switch-icon-right"><i data-feather="x"></i></span>
          </label>
        </div>
        <h5>Status</h5>
        <!-- <input type="number" min="0" step="0.1" name="priceValue1" #FPrice1Ref="ngModel" [(ngModel)]="currentProduct.pricing.weekly" placeholder="0.00" aria-label="Amount (to the nearest dollar)" class="form-control"> -->
      </div>
      <div class="col-12 mb-2" style="text-align-last: center;">
        <div class="custom-control custom-switch custom-switch" >
          <input type="checkbox" class="custom-control-input" [disabled]="!currentPaymentMethod.hasActiveStatus" id="primaryMethodSwitch" [(ngModel)]="currentPaymentMethod.primary_method" [checked]="currentPaymentMethod.primary_method" />
          <label class="custom-control-label" for="primaryMethodSwitch">
            <span class="switch-icon-left"><i data-feather="check"></i></span>
            <span class="switch-icon-right"><i data-feather="x"></i></span>
          </label>
        </div>
        <h5>Primary Method</h5>
        <!-- <input type="number" min="0" step="0.1" name="priceValue1" #FPrice1Ref="ngModel" [(ngModel)]="currentProduct.pricing.weekly" placeholder="0.00" aria-label="Amount (to the nearest dollar)" class="form-control"> -->
      </div>
      <div class="col-12 mb-2">
        <div class="form-group">
          <h5>Description</h5>
          <!-- <quill-editor [(ngModel)]="currentPaymentMethod.description" id="methodDescription" [readOnly]="false" name="method-content">
            <div quill-editor-toolbar style="display: none;">
            </div>  
          </quill-editor> -->
          <fieldset class="form-label-group mb-0">
            <textarea
              #textLength
              id="methodDescription"
              name="method-content"
              class="form-control char-textarea"
              placeholder="Description"
              [(ngModel)]="currentPaymentMethod.description"
              [maxlength]="30"
              rows="2"
            ></textarea>
          </fieldset>
          <small class="textarea-counter-value float-right"
            ><span *ngIf="currentPaymentMethod.description" class="char-count">{{ currentPaymentMethod.description.length }}</span>
            <span *ngIf="!currentPaymentMethod.description" class="char-count">0 </span> / 30
          </small>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button 
    type="button" 
    class="btn btn-primary"
    [disabled]="loadingbtn"
    (click)="sendEditPaymentMethod()" 
    rippleEffect>
    <span *ngIf="loadingbtn" class="spinner-border spinner-border-sm mr-1"></span>

      Save
    </button>
    <button type="button" class="btn btn-secondary" (click)="modal.close('Cancel')" rippleEffect>
      Cancel
    </button>
  </div>
</ng-template>
<!-- / Modal -->

